module.exports = __webpack_public_path__ + "img/hxb.fef57d96.jpg";